import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { host } from "../../../../configuraciones";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CloseIcon from '@mui/icons-material/Close';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import BusinessIcon from '@mui/icons-material/Business';
import SearchIcon from '@mui/icons-material/Search';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CircularProgress from '@mui/material/CircularProgress';

const EnvasadoNoTerminadoSection = ({
  idLogin,
  noTerminadoRecords,
  granelRecords = [],
  isFormOpen,
  setIsFormOpen,
  fechaMovimiento,
  setFechaMovimiento,
  botCaja,
  setBotCaja,
  marca,
  setMarca,
  noLoteGranel,
  setNoLoteGranel,
  volumenEnvasar,
  setVolumenEnvasar,
  noInformeAprobacion,
  setNoInformeAprobacion,
  loteEnvasado,
  setLoteEnvasado,
  categoria,
  setCategoria,
  clase,
  setClase,
  ingrediente,
  setIngrediente,
  edad,
  setEdad,
  tipoMaguey,
  setTipoMaguey,
  noAnalisis,
  setNoAnalisis,
  capacidad,
  setCapacidad,
  pctAlc,
  setPctAlc,
  invInicialCajas,
  setInvInicialCajas,
  invInicialBotellas,
  setInvInicialBotellas,
  entradaProcedencia,
  setEntradaProcedencia,
  entradaCajas,
  setEntradaCajas,
  entradaBotellas,
  setEntradaBotellas,
  salidaCajas,
  setSalidaCajas,
  salidaBotellas,
  setSalidaBotellas,
  salidaDestino,
  setSalidaDestino,
  invFinalCajas,
  setInvFinalCajas,
  invFinalBotellas,
  setInvFinalBotellas,
  mermas,
  setMermas,
  observaciones,
  setObservaciones,
  handleSaveNoTerminado,
  onCompleteEnvasado,
  onSaveHologramas,
  onValidarInspector
}) => {


  // MODAL 2: CONTROL DE HOLOGRAMAS (SECCIÓN V - ASIGNACIÓN Y TÉRMINO)
  const [isHologramasModalOpen, setIsHologramasModalOpen] = useState(false);
  const [selectedRecordForHologramas, setSelectedRecordForHologramas] = useState(null);

  // Form states for Hologramas Modal con soporte para múltiples rangos dinámicos
  const [modalRangosHologramas, setModalRangosHologramas] = useState([
    {
      id: 1,
      prefijo: "A",
      rango1: "",
      rango2: "",
      rangoHologramas: "",
      cantidad: ""
    }
  ]);

  const handleAddModalRangoHolograma = () => {
    const nextId = modalRangosHologramas.length > 0 ? Math.max(...modalRangosHologramas.map(r => r.id)) + 1 : 1;
    setModalRangosHologramas(prev => [
      ...prev,
      {
        id: nextId,
        prefijo: "A",
        rango1: "",
        rango2: "",
        rangoHologramas: "",
        cantidad: ""
      }
    ]);
  };

  const handleRemoveModalRangoHolograma = (idToRemove) => {
    if (modalRangosHologramas.length <= 1) {
      setModalRangosHologramas([
        {
          id: 1,
          prefijo: "A",
          rango1: "",
          rango2: "",
          rangoHologramas: "",
          cantidad: ""
        }
      ]);
      return;
    }
    setModalRangosHologramas(prev => prev.filter(r => r.id !== idToRemove));
  };

  const handleUpdateModalRangoHolograma = (id, field, value) => {
    setModalRangosHologramas(prev => prev.map(r => {
      if (r.id !== id) return r;

      const updated = { ...r, [field]: value };

      if (field === "prefijo" || field === "rango1" || field === "rango2") {
        const pref = (field === "prefijo" ? value : (r.prefijo || "A")).trim().toUpperCase();
        const r1Val = field === "rango1" ? value : (r.rango1 ?? "");
        const r2Val = field === "rango2" ? value : (r.rango2 ?? "");

        updated.prefijo = pref;
        updated.rango1 = r1Val;
        updated.rango2 = r2Val;

        const s1 = String(r1Val).trim();
        const s2 = String(r2Val).trim();

        if (s1 !== "" && s2 !== "") {
          const n1 = parseInt(s1, 10);
          const n2 = parseInt(s2, 10);

          if (!isNaN(n1) && !isNaN(n2) && n2 >= n1) {
            const count = n2 - n1 + 1;
            updated.cantidad = count.toString();
            updated.rangoHologramas = `${pref}${s1} - ${pref}${s2}`;
          } else {
            updated.cantidad = "0";
            updated.rangoHologramas = `${pref}${s1} - ${pref}${s2} (Inválido)`;
          }
        } else if (s1 !== "") {
          updated.rangoHologramas = `${pref}${s1}`;
          updated.cantidad = "";
        } else {
          updated.rangoHologramas = "";
          updated.cantidad = "";
        }
      }

      return updated;
    }));
  };

  const modalTotalHologramas = modalRangosHologramas.reduce((acc, r) => {
    const n = parseInt(r.cantidad || 0, 10);
    return !isNaN(n) && n > 0 ? acc + n : acc;
  }, 0);

  // =========================================================================
  // ESTADOS Y EFECTOS PARA MARCAS DEL CLIENTE Y MAQUILA (SECCIÓN 2)
  // =========================================================================
  const [misMarcas, setMisMarcas] = useState([]);
  const [cargandoMarcasPropias, setCargandoMarcasPropias] = useState(false);
  const [infoClientePropio, setInfoClientePropio] = useState({ numerosocio: "", nombrerazonsocial: "" });

  const [esMaquila, setEsMaquila] = useState(false);
  const [socioMaquilar, setSocioMaquilar] = useState("");
  const [marcasMaquila, setMarcasMaquila] = useState([]);
  const [verificandoRelacion, setVerificandoRelacion] = useState(false);
  const [relacionResultado, setRelacionResultado] = useState(null);

  // =========================================================================
  // ESTADO PARA RANGOS DE HOLOGRAMAS (PASO 4: CONTROL DE HOLOGRAMAS)
  // =========================================================================
  const [rangosHologramas, setRangosHologramas] = useState([
    {
      id: 1,
      prefijo: "A",
      rango1: "",
      rango2: "",
      rangoHologramas: "",
      rangoInicial: "",
      cantidad: "",
      cantidadInicial: ""
    }
  ]);

  const handleAddRangoHolograma = () => {
    const nextId = rangosHologramas.length > 0 ? Math.max(...rangosHologramas.map(r => r.id)) + 1 : 1;
    setRangosHologramas([
      ...rangosHologramas,
      {
        id: nextId,
        prefijo: "A",
        rango1: "",
        rango2: "",
        rangoHologramas: "",
        rangoInicial: "",
        cantidad: "",
        cantidadInicial: ""
      }
    ]);
  };

  const handleRemoveRangoHolograma = (idToRemove) => {
    if (rangosHologramas.length <= 1) {
      // Si solo queda un registro, se limpian sus campos para que quede sin hologramas
      setRangosHologramas([
        {
          id: 1,
          prefijo: "A",
          rango1: "",
          rango2: "",
          rangoHologramas: "",
          rangoInicial: "",
          cantidad: "",
          cantidadInicial: ""
        }
      ]);
      return;
    }
    setRangosHologramas(rangosHologramas.filter(r => r.id !== idToRemove));
  };

  const handleUpdateRangoHolograma = (id, field, value) => {
    setRangosHologramas(rangosHologramas.map(r => {
      if (r.id !== id) return r;

      const updated = { ...r, [field]: value };

      // Si se modifica prefijo, rango1 o rango2, recalculamos la cantidad y el rango de hologramas
      if (field === "prefijo" || field === "rango1" || field === "rango2") {
        const pref = (field === "prefijo" ? value : (r.prefijo || "A")).trim().toUpperCase();
        const r1Val = field === "rango1" ? value : (r.rango1 ?? "");
        const r2Val = field === "rango2" ? value : (r.rango2 ?? "");

        updated.prefijo = pref;
        updated.rango1 = r1Val;
        updated.rango2 = r2Val;

        const s1 = String(r1Val).trim();
        const s2 = String(r2Val).trim();

        if (s1 !== "" && s2 !== "") {
          const n1 = parseInt(s1, 10);
          const n2 = parseInt(s2, 10);

          if (!isNaN(n1) && !isNaN(n2)) {
            if (n2 >= n1) {
              const diff = (n2 - n1 + 1).toString();
              updated.cantidad = diff;
              updated.cantidadInicial = diff;

              const formatoRango = `${pref}${s1} - ${pref}${s2}`;
              updated.rangoHologramas = formatoRango;
              updated.rangoInicial = formatoRango;
            } else {
              updated.cantidad = "0";
              updated.cantidadInicial = "0";
              updated.rangoHologramas = `${pref}${s1} - ${pref}${s2} (Rango inválido)`;
              updated.rangoInicial = updated.rangoHologramas;
            }
          }
        } else if (s1 !== "" && s2 === "") {
          const parcial = `${pref}${s1}`;
          updated.rangoHologramas = parcial;
          updated.rangoInicial = parcial;
          updated.cantidad = "";
          updated.cantidadInicial = "";
        }
      }

      if (field === "rangoHologramas" || field === "rangoInicial") {
        updated.rangoHologramas = value;
        updated.rangoInicial = value;
      }

      if (field === "cantidad" || field === "cantidadInicial") {
        updated.cantidad = value;
        updated.cantidadInicial = value;
      }

      return updated;
    }));
  };

  const totalHologramasResumen = useMemo(() => {
    let total = 0;
    rangosHologramas.forEach(r => {
      const c = parseInt(r.cantidad || r.cantidadInicial || 0, 10);
      if (!isNaN(c) && c > 0) {
        total += c;
      }
    });
    return {
      total,
      totalRangos: rangosHologramas.length
    };
  }, [rangosHologramas]);

  const currentLoginId = useMemo(() => {
    if (idLogin) return idLogin;
    try {
      const u = JSON.parse(localStorage.getItem("usuario") || "{}");
      return u?.user?.[0]?.id || u?.idlogin || 3462;
    } catch (e) {
      return 3462;
    }
  }, [idLogin]);

  // Cargar marcas propias del cliente desde la BD
  useEffect(() => {
    if (!currentLoginId) return;

    let isMounted = true;
    setCargandoMarcasPropias(true);

    axios.get(`${host}InformacionValida/obtenerClientePorLogin/${currentLoginId}`)
      .then((res) => {
        if (!isMounted) return;
        const clienteData = res.data?.data;
        if (clienteData) {
          setInfoClientePropio({
            numerosocio: clienteData.numerosocio || "",
            nombrerazonsocial: clienteData.nombrerazonsocial || ""
          });

          const marcasList = [];
          if (Array.isArray(clienteData.marcascliente)) {
            clienteData.marcascliente.forEach((mc) => {
              if (!mc.isbaja && mc.marca && mc.marca.trim()) {
                marcasList.push(mc.marca.trim());
              }
            });
          }
          if (Array.isArray(clienteData.marcasproductoconmezcalcliente)) {
            clienteData.marcasproductoconmezcalcliente.forEach((mc) => {
              if (!mc.isbaja && mc.marca && mc.marca.trim()) {
                marcasList.push(mc.marca.trim());
              }
            });
          }

          const marcasUnicas = Array.from(new Set(marcasList));
          setMisMarcas(marcasUnicas);

          if (!esMaquila && marcasUnicas.length > 0 && !marca) {
            setMarca(marcasUnicas[0]);
          }
        }
      })
      .catch((err) => {
        console.error("Error al obtener marcas del cliente:", err);
      })
      .finally(() => {
        if (isMounted) setCargandoMarcasPropias(false);
      });

    return () => {
      isMounted = false;
    };
  }, [currentLoginId]);

  // Verificar relación de maquila con el socio indicado
  const handleVerificarRelacion = async (socio) => {
    const socioTarget = (socio !== undefined ? socio : socioMaquilar).trim();
    if (!socioTarget) {
      Swal.fire({
        icon: "warning",
        title: "Número de socio requerido",
        text: "Por favor ingrese el número de socio del cliente al que brindará servicio de maquila.",
        confirmButtonColor: "#2563eb"
      });
      return;
    }

    setVerificandoRelacion(true);
    setRelacionResultado(null);

    try {
      const res = await axios.get(
        `${host}InformacionValida/verificarRelacionMaquila/${currentLoginId}/${encodeURIComponent(socioTarget)}`
      );
      const data = res.data?.data;
      setRelacionResultado(data);

      if (data?.tieneRelacion) {
        const marcasDisp = Array.isArray(data.marcas) ? data.marcas : [];
        setMarcasMaquila(marcasDisp);
        if (marcasDisp.length > 0) {
          setMarca(marcasDisp[0]);
        }
        Swal.fire({
          icon: "success",
          title: "Relación de Maquila Confirmada",
          html: `<div style="text-align: left; font-size: 14px; line-height: 1.5;">
                  <p><b>Socio Maquilado:</b> ${data.clienteMaquilado?.numerosocio || socioTarget}</p>
                  <p><b>Razón Social:</b> ${data.clienteMaquilado?.nombrerazonsocial || "N/A"}</p>
                  <p style="margin-top: 8px;"><b>Marcas autorizadas:</b> ${marcasDisp.length > 0 ? marcasDisp.join(", ") : "Marcas vigentes autorizadas"}</p>
                 </div>`,
          confirmButtonColor: "#16a34a"
        });
      } else {
        setMarcasMaquila([]);
        setMarca("");
        Swal.fire({
          icon: "warning",
          title: "Sin Relación de Maquila",
          html: `<div style="text-align: left; font-size: 14px; line-height: 1.5;">
                  <p style="color: #b45309; font-weight: 600;">${data?.mensaje || "No se encontró una relación de maquila registrada con este socio en la base de datos."}</p>
                  <p style="margin-top: 8px; color: #4b5563;">Para poder envasar producto de este cliente, es indispensable tramitar previamente la relación de maquila ante COMERCAM.</p>
                 </div>`,
          confirmButtonColor: "#d97706"
        });
      }
    } catch (error) {
      console.error("Error al verificar maquila:", error);
      const msg = error.response?.data?.message || "No se pudo verificar la relación con el servidor.";
      setRelacionResultado({
        tieneRelacion: false,
        mensaje: msg
      });
      Swal.fire({
        icon: "error",
        title: "Error de Validación",
        text: msg,
        confirmButtonColor: "#dc2626"
      });
    } finally {
      setVerificandoRelacion(false);
    }
  };

  const handleToggleMaquila = (activarMaquila) => {
    setEsMaquila(activarMaquila);
    setMarca("");
    if (!activarMaquila) {
      if (misMarcas.length > 0) {
        setMarca(misMarcas[0]);
      }
    } else {
      if (marcasMaquila.length > 0) {
        setMarca(marcasMaquila[0]);
      }
    }
  };

  // Handlers for opening modals

  const handleOpenHologramasModal = (rec) => {
    setSelectedRecordForHologramas(rec);
    if (rec.rangosHologramas && Array.isArray(rec.rangosHologramas) && rec.rangosHologramas.length > 0) {
      setModalRangosHologramas(rec.rangosHologramas.map((r, i) => ({
        id: i + 1,
        prefijo: r.prefijo || "A",
        rango1: r.rango1 || "",
        rango2: r.rango2 || "",
        rangoHologramas: r.rangoHologramas || r.rangoInicial || "",
        cantidad: r.cantidad || r.cantidadInicial || ""
      })));
    } else {
      setModalRangosHologramas([
        {
          id: 1,
          prefijo: "A",
          rango1: "",
          rango2: "",
          rangoHologramas: "",
          cantidad: ""
        }
      ]);
    }
    setIsHologramasModalOpen(true);
  };

  const handleConfirmHologramas = () => {
    if (!selectedRecordForHologramas) return;

    // Verificar si hay folios de hologramas registrados
    const rangosValidos = modalRangosHologramas.filter(r => {
      const cant = parseInt(r.cantidad || 0, 10);
      return cant > 0 && r.rangoHologramas && !r.rangoHologramas.includes("Inválido");
    });

    if (rangosValidos.length === 0 || modalTotalHologramas <= 0) {
      alert("Para terminar el envasado es necesario registrar al menos un rango de hologramas válido (prefijo, rango inicial y rango final).");
      return;
    }

    const rangosTexto = rangosValidos.map(r => r.rangoHologramas).join(", ");

    const hologramData = {
      rangosHologramas: rangosValidos,
      invInicialRango: rangosTexto,
      invInicialCant: modalTotalHologramas.toString(),
      salidaRango: rangosTexto,
      salidaCant: modalTotalHologramas.toString(),
      invFinalRango: rangosTexto,
      invFinalCant: modalTotalHologramas.toString(),
      totalHologramas: modalTotalHologramas,
      observaciones: `Hologramas asignados para terminar lote ${selectedRecordForHologramas.loteEnvasado}: ${rangosTexto}`
    };

    if (onSaveHologramas) {
      onSaveHologramas(selectedRecordForHologramas, hologramData);
    }

    if (onCompleteEnvasado) {
      const finishedData = {
        noInformeAprobacion: selectedRecordForHologramas.noInformeAprobacion || "INF-APR-ET-102",
        fechaAprobacionEtiqueta: selectedRecordForHologramas.fechaMovimiento || new Date().toISOString().split("T")[0],
        claseEtiqueta: selectedRecordForHologramas.clase || "Joven / Blanco",
        ingredientesEtiqueta: selectedRecordForHologramas.ingrediente || "",
        tipoMagueyEtiqueta: selectedRecordForHologramas.tipoMaguey || "Espadín",
        pctAlcEtiqueta: selectedRecordForHologramas.pctAlc || "48.5",
        invInicialCajas: selectedRecordForHologramas.cajas || "0",
        invInicialBotellas: selectedRecordForHologramas.botellas || modalTotalHologramas.toString(),
        entradaProcedencia: `Envasado terminado con hologramas (Lote ${selectedRecordForHologramas.loteEnvasado})`,
        entradaCajas: selectedRecordForHologramas.cajas || "0",
        entradaBotellas: selectedRecordForHologramas.botellas || modalTotalHologramas.toString(),
        salidaCajas: "0",
        salidaBotellas: "0",
        salidaDestino: "Almacén de Producto Terminado",
        invFinalCajas: selectedRecordForHologramas.cajas || "0",
        invFinalBotellas: selectedRecordForHologramas.botellas || modalTotalHologramas.toString(),
        observaciones: `Lote completado con ${modalTotalHologramas} hologramas (${rangosTexto}).`,
        rangosHologramas: rangosValidos,
        totalHologramas: modalTotalHologramas
      };

      onCompleteEnvasado(selectedRecordForHologramas, finishedData);
    }

    setIsHologramasModalOpen(false);
    alert(`¡Hologramas registrados exitosamente! El lote ${selectedRecordForHologramas.loteEnvasado} avanzó a Envasado Terminado (Sección IV) en estatus 'En revisión'.`);
  };

  // Local fallbacks para volumen a envasar e informe de aprobación
  const [localVolumenEnvasar, setLocalVolumenEnvasar] = useState("750");
  const currentVolumenEnvasar = volumenEnvasar !== undefined ? volumenEnvasar : localVolumenEnvasar;
  const handleSetVolumenEnvasar = setVolumenEnvasar || setLocalVolumenEnvasar;

  const [localNoInformeAprobacion, setLocalNoInformeAprobacion] = useState("INF-APR-ET-102");
  const currentNoInformeAprobacion = noInformeAprobacion !== undefined ? noInformeAprobacion : localNoInformeAprobacion;
  const handleSetNoInformeAprobacion = setNoInformeAprobacion || setLocalNoInformeAprobacion;

  // Convertir capacidad/presentación a Litros
  const parseCapacityInLiters = (capStr) => {
    if (!capStr) return 0.75;
    const str = String(capStr).trim().toLowerCase();
    if (str.includes("ml")) {
      const n = parseFloat(str.replace(/[^0-9.]/g, ""));
      return n > 0 ? n / 1000 : 0.75;
    }
    if (str.includes("l")) {
      const n = parseFloat(str.replace(/[^0-9.]/g, ""));
      return n > 0 ? n : 0.75;
    }
    const n = parseFloat(str);
    if (isNaN(n) || n <= 0) return 0.75;
    return n > 10 ? n / 1000 : n;
  };

  // Buscar el registro de lote a granel seleccionado
  const selectedGranel = useMemo(() => {
    if (!noLoteGranel || noLoteGranel === "manual") return null;
    return (granelRecords || []).find(r =>
      r.noLote === noLoteGranel ||
      r.no_lote === noLoteGranel ||
      String(r.id) === String(noLoteGranel) ||
      String(r.noProduccion) === String(noLoteGranel)
    );
  }, [noLoteGranel, granelRecords]);

  // Manejador al seleccionar un lote a granel: auto-completar y desplegar características
  const handleSelectGranel = (loteVal) => {
    if (setNoLoteGranel) setNoLoteGranel(loteVal);
    if (!loteVal || loteVal === "manual") return;

    const found = (granelRecords || []).find(r =>
      r.noLote === loteVal ||
      r.no_lote === loteVal ||
      String(r.id) === String(loteVal) ||
      String(r.noProduccion) === String(loteVal)
    );

    if (found) {
      if (found.categoria && setCategoria) setCategoria(found.categoria);
      if (found.clase && setClase) setClase(found.clase);
      const maguey = found.tipoMaguey || found.especie || found.materiaPrima || found.tipo_maguey || "";
      if (maguey && setTipoMaguey) setTipoMaguey(maguey);
      const fq = found.noAnalisis || found.clave_fq || found.noAnalisisFisicoquimico || found.no_analisis || "";
      if (fq && fq !== "-" && setNoAnalisis) setNoAnalisis(fq);
      const alc = found.invFinalAlc || found.porcentaje_alc_vol || found.alcFinal || found.entradaAlc || "";
      if (alc && setPctAlc) setPctAlc(String(alc));
      const ing = found.ingrediente || found.ingredientes || (maguey ? `100% ${maguey}` : "");
      if (ing && setIngrediente) setIngrediente(ing);
      if (found.edad && setEdad) setEdad(found.edad);

      // Si hay volumen disponible en el granel, sugerir volumen a envasar si no se ha definido
      const volDisp = found.invFinalVol || found.litros || "";
      if (volDisp && (!currentVolumenEnvasar || currentVolumenEnvasar === "0")) {
        handleSetVolumenEnvasar(String(volDisp));
      }
    }
  };

  // Cálculo automático de entradas número de botellas: volumen a envasar / presentación
  useEffect(() => {
    const volNum = parseFloat(currentVolumenEnvasar);
    const presLitros = parseCapacityInLiters(capacidad);
    if (!isNaN(volNum) && volNum > 0 && presLitros > 0) {
      const botellasCalculadas = Math.round(volNum / presLitros);
      if (setEntradaBotellas) {
        setEntradaBotellas(botellasCalculadas.toString());
      }
      const bCaja = parseInt(String(botCaja).replace(/[^0-9]/g, ""), 10) || 12;
      if (bCaja > 0 && setEntradaCajas) {
        const cajasCalculadas = Math.floor(botellasCalculadas / bCaja);
        setEntradaCajas(cajasCalculadas.toString());
      }
    }
  }, [currentVolumenEnvasar, capacidad, botCaja, setEntradaBotellas, setEntradaCajas]);

  // Calculations for main form
  const initCajasNum = parseInt(invInicialCajas || 0, 10);
  const initBotNum = parseInt(invInicialBotellas || 0, 10);
  const entCajasNum = parseInt(entradaCajas || 0, 10);
  const entBotNum = parseInt(entradaBotellas || 0, 10);
  const salCajasNum = parseInt(salidaCajas || 0, 10);
  const salBotNum = parseInt(salidaBotellas || 0, 10);

  const calcFinalCajas = Math.max(0, (initCajasNum + entCajasNum) - salCajasNum);
  const calcFinalBotellas = Math.max(0, (initBotNum + entBotNum) - salBotNum);

  // Siempre mostrar la tabla y abrir formulario en Modal

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <div>
          <h2>Inventarios de Mezcal Envasado "No Terminado" (Sección III)</h2>
          <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "13px" }}>
            Botella desnuda / sin etiquetar. Desde la tabla puede asignar <strong>Hologramas</strong> (Sección V) o gestionar estatus.
          </p>
        </div>
        <button
          onClick={() => setIsFormOpen(true)}
          className="btn-add-new"
        >
          <AddIcon style={{ fontSize: 18 }} />
          <span>Registro de envasado de producto</span>
        </button>
      </div>

      <div className="records-list-wrapper">
        <table className="records-table">
          <thead>
            <tr>
              {/* Identificación */}
              <th>Fecha Mov.</th>
              <th>Marca</th>
              <th>Lote Granel</th>
              <th>Lote Env.</th>

              {/* Cierre y Acciones */}
              <th>Etapa Proceso</th>
              <th>Estatus COMERCAM</th>
              <th style={{ minWidth: "220px", textAlign: "center" }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {noTerminadoRecords.map((rec, i) => {
              const stage = rec.estadoProceso || "no_terminado";
              return (
                <tr key={i}>
                  <td>{rec.fechaMovimiento}</td>
                  <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                  <td>{rec.noLoteGranel}</td>
                  <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.loteEnvasado}</td>

                  <td>
                    <span className={`badge-stage ${stage}`}>
                      {stage === "hologramado" ? "🟢 Hologramado" : stage === "terminado" ? "🔵 Terminado" : "🟡 No Terminado"}
                    </span>
                  </td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: "6px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                      {rec.status === "revision" && onValidarInspector && (
                        <button
                          onClick={() => onValidarInspector(rec)}
                          style={{
                            background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                            border: "none",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            fontSize: "11px",
                            fontWeight: 700,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            boxShadow: "0 2px 4px rgba(5, 150, 105, 0.2)"
                          }}
                          title="Validar por Inspector de Unidad de Inspección (Otorgar V.Bo.)"
                        >
                          <CheckCircleIcon style={{ fontSize: 14 }} />
                          <span>Validar UI</span>
                        </button>
                      )}


                      <button
                        onClick={() => handleOpenHologramasModal(rec)}
                        style={{
                          background: "linear-gradient(135deg, #8e44ad 0%, #732d91 100%)",
                          border: "none",
                          color: "#fff",
                          borderRadius: "6px",
                          padding: "6px 10px",
                          fontSize: "11px",
                          fontWeight: 700,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px"
                        }}
                        title="Control de Hologramas (Sección V - Imagen 4)"
                      >
                        <ConfirmationNumberIcon style={{ fontSize: 14 }} />
                        <span>Hologramas</span>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>



      {/* MODAL: CONTROL DE HOLOGRAMAS (SECCIÓN V - ASIGNACIÓN Y TÉRMINO) */}
      {isHologramasModalOpen && selectedRecordForHologramas && createPortal(
        <div className="modal-backdrop-custom animate-fadeIn" onClick={() => setIsHologramasModalOpen(false)}>
          <div
            className="detail-modal-card animate-fadeIn"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "850px", maxHeight: "90vh", display: "flex", flexDirection: "column" }}
          >
            {/* Header del Modal */}
            <div className="detail-modal-header" style={{ background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 100%)", color: "white", padding: "16px 22px" }}>
              <div className="detail-modal-title-box">
                <div className="detail-modal-badge-row" style={{ marginBottom: "4px" }}>
                  <span className="badge-modal-tag" style={{ background: "rgba(255,255,255,0.2)", color: "white" }}>
                    CONTROL Y AUDITORÍA
                  </span>
                  <span className="badge-status enviada" style={{ background: "rgba(255,255,255,0.25)", color: "#FFFFFF" }}>
                    SECCIÓN V: CONTROL DE HOLOGRAMAS
                  </span>
                </div>
                <h1 className="detail-modal-title" style={{ color: "white", fontSize: "19px", margin: 0 }}>
                  Control de Hologramas - Terminar Envasado
                </h1>
                <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px", marginTop: "3px" }}>
                  Asociado a Lote: <strong>{selectedRecordForHologramas.loteEnvasado}</strong> | Marca: {selectedRecordForHologramas.marca} | Botellas: {selectedRecordForHologramas.botellas || "N/A"}
                </div>
              </div>

              <button
                type="button"
                onClick={() => setIsHologramasModalOpen(false)}
                className="detail-modal-close-btn"
                title="Cerrar ventana"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Body del Modal */}
            <div
              className="detail-modal-body"
              style={{ padding: "20px 24px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "16px", background: "#F8FAFC" }}
            >
              {/* TARJETA: 4. Control de Hologramas (Rango de Hologramas) */}
              <div className="modal-section-card" style={{ background: "#FFFFFF", border: "1.5px solid #E9D5FF", borderRadius: "14px", padding: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "12px", marginBottom: "16px" }}>
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "rgba(107, 33, 168, 0.1)",
                      color: "#6B21A8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}>
                      <ConfirmationNumberIcon style={{ fontSize: 24 }} />
                    </div>
                    <div>
                      <h2 style={{ fontSize: "16px", fontWeight: 700, color: "#1E293B", margin: 0 }}>
                        4. Control de Hologramas (Rango de Hologramas)
                      </h2>
                      <p style={{ fontSize: "13px", color: "#64748B", margin: "2px 0 0 0" }}>
                        Defina los folios inicial y final (con Prefijo A por defecto) para el cálculo automático de hologramas.
                      </p>
                      <div style={{ marginTop: "6px", display: "inline-block", background: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: "6px", padding: "6px 10px", fontSize: "12px", color: "#1E40AF", lineHeight: "1.4" }}>
                        ℹ️ <strong>Regla de negocio:</strong> Si registra folios de hologramas, el lote avanzará a <strong>Envasado Terminado (Sección IV)</strong> en estatus <em>En revisión</em>. Si deja este apartado sin folios, permanecerá como <strong>No Terminado (Botella sin etiquetar)</strong>.
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={handleAddModalRangoHolograma}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      border: "none",
                      background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 100%)",
                      color: "#FFFFFF",
                      fontSize: "12.5px",
                      fontWeight: 700,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      boxShadow: "0 2px 6px rgba(107, 33, 168, 0.25)",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <AddIcon style={{ fontSize: 17 }} />
                    <span>Agregar otro rango de hologramas</span>
                  </button>
                </div>

                {/* LISTA DINÁMICA DE RANGOS DE HOLOGRAMAS */}
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {modalRangosHologramas.map((rangoItem, index) => (
                    <div
                      key={rangoItem.id}
                      style={{
                        padding: "16px",
                        background: "#FFFFFF",
                        border: "1.5px solid #E9D5FF",
                        borderRadius: "12px",
                        boxShadow: "0 1px 4px rgba(107, 33, 168, 0.05)"
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                        <span style={{
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "#6B21A8",
                          background: "#F3E8FF",
                          padding: "4px 12px",
                          borderRadius: "12px"
                        }}>
                          Rango #{index + 1}
                        </span>

                        {modalRangosHologramas.length > 1 && (
                          <button
                            type="button"
                            onClick={() => handleRemoveModalRangoHolograma(rangoItem.id)}
                            style={{
                              border: "none",
                              background: "transparent",
                              color: "#DC2626",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              fontSize: "12px",
                              fontWeight: 600,
                              padding: "4px 8px",
                              borderRadius: "6px"
                            }}
                            title="Eliminar este rango"
                          >
                            <CloseIcon style={{ fontSize: 16 }} />
                            <span>Quitar rango</span>
                          </button>
                        )}
                      </div>

                      {/* FILA 1: PREFIJO, RANGO 1 Y RANGO 2 */}
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                        gap: "12px",
                        marginBottom: "12px"
                      }}>
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <select
                            value="A"
                            disabled
                            className="custom-select-field"
                            style={{ fontWeight: 700, background: "#F1F5F9", color: "#6B21A8", cursor: "not-allowed" }}
                            title="Prefijo A fijado por defecto"
                          >
                            <option value="A">Prefijo A</option>
                          </select>
                          <label className="custom-input-label">Prefijo (Fijo) *</label>
                        </div>

                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={rangoItem.rango1 ?? ""}
                            onChange={e => handleUpdateModalRangoHolograma(rangoItem.id, "rango1", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. 0123"
                            style={{ fontWeight: 600, background: "#FFFFFF" }}
                          />
                          <label className="custom-input-label">Rango 1 (Inicial) *</label>
                        </div>

                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={rangoItem.rango2 ?? ""}
                            onChange={e => handleUpdateModalRangoHolograma(rangoItem.id, "rango2", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. 0500"
                            style={{ fontWeight: 600, background: "#FFFFFF" }}
                          />
                          <label className="custom-input-label">Rango 2 (Final) *</label>
                        </div>
                      </div>

                      {/* FILA 2: RANGO DE HOLOGRAMAS Y CANTIDAD */}
                      <div className="species-grid" style={{ marginBottom: 0 }}>
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={rangoItem.rangoHologramas || ""}
                            onChange={e => handleUpdateModalRangoHolograma(rangoItem.id, "rangoHologramas", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. A0123 - A0500"
                            style={{ fontWeight: 700, background: "#F8FAFC", color: "#1E293B" }}
                          />
                          <label className="custom-input-label">Rango de Hologramas</label>
                        </div>

                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="number"
                            value={rangoItem.cantidad || ""}
                            onChange={e => handleUpdateModalRangoHolograma(rangoItem.id, "cantidad", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. 378"
                            style={{
                              fontWeight: 800,
                              background: "#FAF5FF",
                              color: "#6B21A8",
                              borderColor: "#D8B4FE"
                            }}
                          />
                          <label className="custom-input-label">Cantidad (Hologramas)</label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* RESUMEN DE TOTALES */}
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "16px",
                  padding: "12px 18px",
                  background: "#F3E8FF",
                  borderRadius: "10px",
                  fontSize: "13.5px",
                  color: "#581C87",
                  fontWeight: 700
                }}>
                  <span>Rangos Registrados: {modalRangosHologramas.length}</span>
                  <span style={{
                    background: "#6B21A8",
                    color: "#FFFFFF",
                    padding: "6px 14px",
                    borderRadius: "6px",
                    fontSize: "13px",
                    boxShadow: "0 2px 4px rgba(107, 33, 168, 0.2)"
                  }}>
                    Total Hologramas: {modalTotalHologramas}
                  </span>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="detail-modal-footer" style={{ padding: "16px 24px", display: "flex", justifyContent: "flex-end", gap: "12px", borderTop: "1px solid #E2E8F0", background: "#FFFFFF" }}>
              <button
                type="button"
                onClick={() => setIsHologramasModalOpen(false)}
                className="btn-cancel-modal"
                style={{ padding: "10px 20px", borderRadius: "10px", border: "1px solid #CBD5E1", background: "#FFFFFF", color: "#475569", fontWeight: 700, cursor: "pointer" }}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleConfirmHologramas}
                className="btn-submit-modal"
                style={{ padding: "10px 22px", borderRadius: "10px", border: "none", background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 100%)", color: "#FFFFFF", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", boxShadow: "0 3px 8px rgba(107, 33, 168, 0.3)" }}
              >
                <ConfirmationNumberIcon style={{ fontSize: 18 }} />
                <span>Guardar Hologramas y Terminar Envasado</span>
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* =========================================================================
            MODAL DE NUEVO REGISTRO DE ENVASADO NO TERMINADO (SECCIÓN III)
        ========================================================================= */}
      {isFormOpen && createPortal(
        <div className="modal-backdrop-custom animate-fadeIn" onClick={() => setIsFormOpen(false)}>
          <div
            className="detail-modal-card animate-fadeIn"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "900px", maxHeight: "90vh", overflowY: "auto" }}
          >
            {/* Header del Modal */}
            <div className="detail-modal-header" style={{ background: "linear-gradient(135deg, #065F46 0%, #059669 100%)", color: "white", padding: "16px 22px" }}>
              <div className="detail-modal-title-box">
                <div className="detail-modal-badge-row" style={{ marginBottom: "4px" }}>
                  <span className="badge-modal-tag" style={{ background: "rgba(255,255,255,0.2)", color: "white" }}>
                    NUEVO REGISTRO
                  </span>
                  <span className="badge-status enviada" style={{ background: "rgba(255,255,255,0.25)", color: "#FFFFFF" }}>
                    SECCIÓN III: ENVASADO NO TERMINADO
                  </span>
                </div>
                <h1 className="detail-modal-title" style={{ color: "white", fontSize: "19px" }}>
                  Registro de Envasado de Producto (Botella sin Etiquetar)
                </h1>
              </div>

              <button
                type="button"
                onClick={() => setIsFormOpen(false)}
                className="detail-modal-close-btn"
                title="Cerrar ventana"
                aria-label="Cerrar modal"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Formulario en Modal */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (esMaquila) {
                  if (!relacionResultado || !relacionResultado.tieneRelacion) {
                    Swal.fire({
                      icon: "warning",
                      title: "Relación de Maquila Requerida",
                      text: "No puede registrar un producto envasado bajo maquila sin verificar previamente una relación autorizada y vigente en COMERCAM.",
                      confirmButtonColor: "#d97706"
                    });
                    return;
                  }
                  if (!marca || !marca.trim()) {
                    Swal.fire({
                      icon: "warning",
                      title: "Marca Requerida",
                      text: "Debe seleccionar o ingresar una marca autorizada para la maquila.",
                      confirmButtonColor: "#d97706"
                    });
                    return;
                  }
                }
                handleSaveNoTerminado("revision", { rangosHologramas });
              }}
              className="detail-modal-body"
              style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: "16px" }}
            >
              {/* PASO 1: ORIGEN A GRANEL Y VOLUMEN A ENVASAR */}
              <section className="detail-card detail-card-accent-left-green">
                <header className="detail-card-header">
                  <div className="detail-card-icon-wrapper-green">
                    <LocalBarIcon />
                  </div>
                  <div className="detail-card-title-wrapper">
                    <h2>1. Origen: Lote a Granel y Volumen a Envasar</h2>
                    <p>Seleccione el lote a granel en envasado y el volumen en litros a procesar</p>
                  </div>
                </header>

                <div className="species-grid">
                  <div className="custom-input-group">
                    <select
                      value={noLoteGranel}
                      onChange={e => handleSelectGranel(e.target.value)}
                      className="custom-select-field"
                      style={{ padding: "18px 16px 8px 16px", fontWeight: 600 }}
                    >
                      <option value="">-- Seleccionar Lote a Granel en Envasado --</option>
                      {(granelRecords || []).map((r, idx) => {
                        const fq = r.clave_fq || r.claveFQ || r.noAnalisis || r.noAnalisisFisicoquimico || r.no_analisis || "";
                        const maguey = r.tipoMaguey || r.especie || r.tipo_maguey || "";
                        const vol = r.invFinalVol !== undefined && r.invFinalVol !== "" ? r.invFinalVol : (r.litros || "");
                        return (
                          <option key={idx} value={r.noLote || r.id}>
                            {r.noLote || r.idContenedor} - {r.categoria || 'Mezcal'} ({r.clase || 'Blanco Joven'}){maguey ? ` [${maguey}]` : ''}{fq ? ` [FQ: ${fq}]` : ''} {vol ? `(Disponible: ${vol} L)` : ''}
                          </option>
                        );
                      })}
                      <option value="manual">➕ Ingreso manual / Otro lote no listado</option>
                    </select>
                    <label className="custom-input-label">Selector de Lote a Granel *</label>
                  </div>

                  <div className="custom-input-group">
                    <input
                      type="number"
                      step="0.1"
                      min="0"
                      value={currentVolumenEnvasar}
                      onChange={e => handleSetVolumenEnvasar(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. 750"
                      style={{ fontWeight: 700, color: "var(--agave-green)" }}
                      required
                    />
                    <label className="custom-input-label">Volumen a Envasar (Litros) *</label>
                    <span className="input-suffix">L</span>
                  </div>
                </div>

                {noLoteGranel === "manual" && (
                  <div className="custom-input-group" style={{ marginTop: 12 }}>
                    <input
                      type="text"
                      value={noLoteGranel === "manual" ? "" : noLoteGranel}
                      onChange={e => setNoLoteGranel(e.target.value)}
                      className="custom-input-field"
                      placeholder="Escriba el número de lote a granel..."
                    />
                    <label className="custom-input-label">Número de Lote a Granel Manual</label>
                  </div>
                )}

                {/* DESPLIEGUE DE CARACTERÍSTICAS DEL LOTE A GRANEL EN ENVASADO */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(74, 93, 35, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%)",
                  border: "1px solid rgba(74, 93, 35, 0.25)",
                  borderRadius: "10px",
                  padding: "14px 16px",
                  marginTop: "14px"
                }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", borderBottom: "1px solid rgba(74, 93, 35, 0.15)", paddingBottom: "6px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <ScienceIcon style={{ color: "var(--agave-green)", fontSize: 18 }} />
                      <strong style={{ color: "var(--agave-green)", fontSize: "13px", letterSpacing: "0.3px" }}>
                        Características del Lote a Granel en Envasado
                      </strong>
                    </div>
                    <span className={`badge-status ${selectedGranel ? "aprobado" : "revision"}`} style={{ fontSize: "11px" }}>
                      {selectedGranel ? "Lote Seleccionado" : "Esperando selección de granel"}
                    </span>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "10px", fontSize: "12px" }}>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Lote Granel Origen:</span>
                      <strong style={{ color: "var(--text-main)" }}>{noLoteGranel || "Sin seleccionar"}</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Categoría:</span>
                      <strong style={{ color: "var(--text-main)" }}>{categoria || "-"}</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Clase:</span>
                      <strong style={{ color: "var(--text-main)" }}>{clase || "-"}</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Tipo de Maguey:</span>
                      <strong style={{ color: "var(--text-main)" }}>{tipoMaguey || "-"}</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>% Alc. Vol.:</span>
                      <strong style={{ color: "var(--copper)" }}>{pctAlc ? `${pctAlc}%` : "-"}</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Nº Análisis FQ:</span>
                      <strong style={{ color: "var(--text-main)" }}>{noAnalisis || "-"}</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Volumen Disponible Granel:</span>
                      <strong style={{ color: "var(--agave-green)" }}>
                        {selectedGranel ? `${selectedGranel.invFinalVol || selectedGranel.litros || '-'} L` : "N/D"}
                      </strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Ingrediente(s):</span>
                      <strong style={{ color: "var(--text-main)" }}>{ingrediente || "100% Maguey"}</strong>
                    </div>
                  </div>
                </div>

                <div className="species-grid" style={{ marginTop: 14 }}>
                  <div className="custom-input-group">
                    <input
                      type="date"
                      value={fechaMovimiento}
                      onChange={e => setFechaMovimiento(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Fecha del Movimiento</label>
                  </div>

                  <div className="custom-input-group">
                    <input
                      type="text"
                      value={loteEnvasado}
                      onChange={e => setLoteEnvasado(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. L-01-ENV-NT"
                      style={{ fontWeight: 600 }}
                    />
                    <label className="custom-input-label">Lote de Envasado *</label>
                  </div>
                </div>
              </section>

              {/* PASO 2: MARCA, INFORME DE APROBACIÓN DE ETIQUETA Y PRESENTACIÓN */}
              <section className="detail-card detail-card-accent-left-copper">
                <header className="detail-card-header">
                  <div className="detail-card-icon-wrapper-copper">
                    <LayersIcon />
                  </div>
                  <div className="detail-card-title-wrapper">
                    <h2>2. Marca, Informe de Etiqueta y Presentación</h2>
                    <p>Seleccione si es marca propia o servicio de maquila, verifique las relaciones y defina el formato</p>
                  </div>
                </header>

                {/* SELECTOR SEGMENTADO: MARCA PROPIA vs SERVICIO DE MAQUILA */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "12px",
                  padding: "12px 16px",
                  background: "#F8FAFC",
                  borderRadius: "10px",
                  border: "1px solid #E2E8F0",
                  marginBottom: "16px"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "13px", fontWeight: 700, color: "#334155", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Modalidad de Envasado:
                    </span>
                    {!esMaquila && infoClientePropio?.numerosocio && (
                      <span style={{ fontSize: "12px", color: "#64748B", background: "#E2E8F0", padding: "2px 8px", borderRadius: "12px" }}>
                        Socio: <b>{infoClientePropio.numerosocio}</b> ({infoClientePropio.nombrerazonsocial})
                      </span>
                    )}
                  </div>

                  <div style={{ display: "inline-flex", background: "#E2E8F0", padding: "3px", borderRadius: "8px" }}>
                    <button
                      type="button"
                      onClick={() => handleToggleMaquila(false)}
                      style={{
                        padding: "7px 18px",
                        fontSize: "13px",
                        fontWeight: 700,
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        transition: "all 0.2s ease",
                        background: !esMaquila ? "#FFFFFF" : "transparent",
                        color: !esMaquila ? "#0F172A" : "#64748B",
                        boxShadow: !esMaquila ? "0 2px 4px rgba(0,0,0,0.1)" : "none"
                      }}
                    >
                      <LocalOfferIcon style={{ fontSize: 16, color: !esMaquila ? "#B45309" : "#94A3B8" }} />
                      <span>Marca Propia</span>
                    </button>

                    <button
                      type="button"
                      onClick={() => handleToggleMaquila(true)}
                      style={{
                        padding: "7px 18px",
                        fontSize: "13px",
                        fontWeight: 700,
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        transition: "all 0.2s ease",
                        background: esMaquila ? "linear-gradient(135deg, #1D4ED8 0%, #2563EB 100%)" : "transparent",
                        color: esMaquila ? "#FFFFFF" : "#64748B",
                        boxShadow: esMaquila ? "0 2px 6px rgba(37,99,235,0.35)" : "none"
                      }}
                    >
                      <BusinessIcon style={{ fontSize: 16, color: esMaquila ? "#FFFFFF" : "#94A3B8" }} />
                      <span>Servicio de Maquila</span>
                    </button>
                  </div>
                </div>

                {/* BLOQUE DE MAQUILA (EN CASO DE SER MAQUILA) */}
                {esMaquila && (
                  <div style={{
                    padding: "16px",
                    background: "#F0F7FF",
                    border: "1px solid #BFDBFE",
                    borderRadius: "10px",
                    marginBottom: "16px",
                    boxShadow: "0 1px 3px rgba(37,99,235,0.08)"
                  }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", flexWrap: "wrap", gap: "8px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <BusinessIcon style={{ fontSize: 20, color: "#1D4ED8" }} />
                        <span style={{ fontSize: "14px", fontWeight: 700, color: "#1E40AF" }}>
                          Identificación del Cliente a Maquilar
                        </span>
                      </div>
                      <span style={{ fontSize: "12px", color: "#64748B" }}>
                        Valida la relación registrada en el padrón de COMERCAM
                      </span>
                    </div>

                    <div style={{ display: "flex", gap: "10px", alignItems: "stretch", flexWrap: "wrap" }}>
                      <div style={{ flex: "1 1 250px", minWidth: "220px" }}>
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={socioMaquilar}
                            onChange={(e) => {
                              setSocioMaquilar(e.target.value);
                              if (relacionResultado) setRelacionResultado(null);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleVerificarRelacion();
                              }
                            }}
                            className="custom-input-field"
                            placeholder="Ingrese No. de Socio (Ej. 01536)..."
                            style={{ fontWeight: 600, background: "#FFFFFF" }}
                          />
                          <label className="custom-input-label">No. de Socio a Maquilar *</label>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() => handleVerificarRelacion()}
                        disabled={verificandoRelacion || !socioMaquilar.trim()}
                        style={{
                          padding: "0 22px",
                          height: "48px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          background: verificandoRelacion || !socioMaquilar.trim() ? "#94A3B8" : "linear-gradient(135deg, #1D4ED8 0%, #2563EB 100%)",
                          color: "#FFFFFF",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: 700,
                          fontSize: "13px",
                          cursor: verificandoRelacion || !socioMaquilar.trim() ? "not-allowed" : "pointer",
                          boxShadow: "0 2px 6px rgba(37,99,235,0.25)",
                          transition: "all 0.2s ease"
                        }}
                      >
                        {verificandoRelacion ? (
                          <>
                            <CircularProgress size={16} color="inherit" />
                            <span>Verificando...</span>
                          </>
                        ) : (
                          <>
                            <SearchIcon style={{ fontSize: 18 }} />
                            <span>Verificar Relación</span>
                          </>
                        )}
                      </button>
                    </div>

                    {/* FEEDBACK Y MENSAJES DE RELACIÓN */}
                    {relacionResultado && (
                      <div style={{ marginTop: "14px" }}>
                        {relacionResultado.tieneRelacion ? (
                          <div style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "12px",
                            padding: "12px 16px",
                            background: "#DCFCE7",
                            border: "1px solid #86EFAC",
                            borderRadius: "8px",
                            color: "#166534"
                          }}>
                            <CheckCircleIcon style={{ color: "#16A34A", fontSize: 22, marginTop: "2px" }} />
                            <div style={{ fontSize: "13px" }}>
                              <strong style={{ fontSize: "14px" }}>✓ Relación de Maquila Confirmada</strong>
                              <div style={{ marginTop: "4px" }}>
                                <b>Socio Maquilado:</b> {relacionResultado.clienteMaquilado?.numerosocio} — {relacionResultado.clienteMaquilado?.nombrerazonsocial}
                              </div>
                              <div style={{ marginTop: "3px", color: "#15803D" }}>
                                <b>Marcas de maquila autorizadas del cliente:</b> {marcasMaquila.length > 0 ? marcasMaquila.join(", ") : "Marcas vigentes autorizadas"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "12px",
                            padding: "14px 16px",
                            background: "#FEE2E2",
                            border: "1px solid #FCA5A5",
                            borderRadius: "8px",
                            color: "#991B1B"
                          }}>
                            <WarningAmberIcon style={{ color: "#DC2626", fontSize: 24, marginTop: "2px" }} />
                            <div style={{ fontSize: "13px" }}>
                              <strong style={{ fontSize: "14px", display: "block", marginBottom: "4px" }}>
                                ⚠️ No tiene relación con el maquilador
                              </strong>
                              <span>{relacionResultado.mensaje}</span>
                              <div style={{ marginTop: "6px", fontSize: "12px", color: "#7F1D1D", fontWeight: 600 }}>
                                Para envasar producto de este cliente, es necesario que ambas partes tramiten previamente el registro de la relación de maquila ante COMERCAM.
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* SELECTORES DE MARCA E INFORME DE ETIQUETA */}
                <div className="species-grid">
                  <div className="custom-input-group">
                    <label className="custom-input-label">
                      {esMaquila ? "Marca de Maquila Autorizada *" : "Marca Comercial del Cliente *"}
                    </label>
                    <select
                      value={marca}
                      onChange={e => setMarca(e.target.value)}
                      className="custom-select-field"
                      style={{ fontWeight: 600 }}
                      required
                      disabled={esMaquila && (!relacionResultado || !relacionResultado.tieneRelacion)}
                    >
                      {esMaquila ? (
                        <>
                          <option value="">
                            {marcasMaquila.length > 0
                              ? "-- Seleccione Marca Autorizada de Maquila --"
                              : "-- Verifique primero el socio con relación --"}
                          </option>
                          {marcasMaquila.map((m, idx) => (
                            <option key={idx} value={m}>
                              {m}
                            </option>
                          ))}
                        </>
                      ) : (
                        <>
                          <option value="">
                            {cargandoMarcasPropias
                              ? "-- Cargando marcas del cliente... --"
                              : (misMarcas.length > 0
                                  ? "-- Seleccione una Marca Comercial --"
                                  : "-- Sin marcas registradas --")}
                          </option>
                          {misMarcas.map((m, idx) => (
                            <option key={idx} value={m}>
                              {m}
                            </option>
                          ))}
                        </>
                      )}
                    </select>

                    {/* Chips de selección rápida si hay marcas cargadas */}
                    {(!esMaquila && misMarcas.length > 0) && (
                      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "6px", marginTop: "8px" }}>
                        <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600 }}>Marcas registradas:</span>
                        {misMarcas.map((m, idx) => (
                          <button
                            key={idx}
                            type="button"
                            onClick={() => setMarca(m)}
                            style={{
                              padding: "2px 8px",
                              fontSize: "11px",
                              fontWeight: 600,
                              borderRadius: "12px",
                              border: marca === m ? "1.5px solid #059669" : "1px solid #CBD5E1",
                              background: marca === m ? "#ECFDF5" : "#FFFFFF",
                              color: marca === m ? "#065F46" : "#475569",
                              cursor: "pointer",
                              transition: "all 0.15s ease"
                            }}
                          >
                            {marca === m ? "✓ " : ""}{m}
                          </button>
                        ))}
                      </div>
                    )}

                    {(esMaquila && marcasMaquila.length > 0) && (
                      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "6px", marginTop: "8px" }}>
                        <span style={{ fontSize: "11px", color: "#1E40AF", fontWeight: 600 }}>Marcas del socio maquilado:</span>
                        {marcasMaquila.map((m, idx) => (
                          <button
                            key={idx}
                            type="button"
                            onClick={() => setMarca(m)}
                            style={{
                              padding: "2px 8px",
                              fontSize: "11px",
                              fontWeight: 600,
                              borderRadius: "12px",
                              border: marca === m ? "1.5px solid #2563EB" : "1px solid #BFDBFE",
                              background: marca === m ? "#DBEAFE" : "#FFFFFF",
                              color: marca === m ? "#1E40AF" : "#1E3A8A",
                              cursor: "pointer",
                              transition: "all 0.15s ease"
                            }}
                          >
                            {marca === m ? "✓ " : ""}{m}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="custom-input-group">
                    <label className="custom-input-label">Inf. de Aprobación de Etiqueta *</label>
                    <input
                      list="informes-aprobacion-list"
                      type="text"
                      value={currentNoInformeAprobacion}
                      onChange={e => handleSetNoInformeAprobacion(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. INF-APR-ET-102"
                      style={{ fontWeight: 600 }}
                      required
                    />
                    <datalist id="informes-aprobacion-list">
                      <option value="INF-APR-ET-102" />
                      <option value="INF-APR-ET-105" />
                      <option value="INF-APR-ET-2026-001" />
                      <option value="INF-APR-ET-2026-002" />
                    </datalist>
                  </div>
                </div>

                <div className="species-grid" style={{ marginTop: 12 }}>
                  <div className="custom-input-group">
                    <select
                      value={capacidad}
                      onChange={e => setCapacidad(e.target.value)}
                      className="custom-select-field"
                      style={{ padding: "18px 16px 8px 16px", fontWeight: 600 }}
                    >
                      <option value="750 ml">750 ml (0.75 L)</option>
                      <option value="700 ml">700 ml (0.70 L)</option>
                      <option value="1000 ml">1000 ml / 1 L (1.00 L)</option>
                      <option value="500 ml">500 ml (0.50 L)</option>
                      <option value="375 ml">375 ml (0.375 L)</option>
                      <option value="250 ml">250 ml (0.25 L)</option>
                      <option value="200 ml">200 ml (0.20 L)</option>
                      <option value="50 ml">50 ml (0.05 L)</option>
                    </select>
                    <label className="custom-input-label">Presentación (Capacidad) *</label>
                  </div>

                  <div className="custom-input-group">
                    <select
                      value={botCaja}
                      onChange={e => setBotCaja(e.target.value)}
                      className="custom-select-field"
                      style={{ padding: "18px 16px 8px 16px" }}
                    >
                      <option value="12 botellas">12 botellas por caja</option>
                      <option value="6 botellas">6 botellas por caja</option>
                      <option value="24 botellas">24 botellas por caja</option>
                      <option value="1 botella">1 botella (Sin caja / Sueltas)</option>
                    </select>
                    <label className="custom-input-label">Botellas por Caja (Bot/Caja)</label>
                  </div>
                </div>
              </section>

              {/* PASO 3: MOVIMIENTOS E INVENTARIO CON CÁLCULO DE ENTRADAS */}
              <section className="detail-card detail-card-accent-left-copper">
                <header className="detail-card-header">
                  <div className="detail-card-icon-wrapper-copper">
                    <ShoppingBagIcon />
                  </div>
                  <div className="detail-card-title-wrapper">
                    <h2>3. Entradas Calculadas de Envasado</h2>
                    <p>Entradas calculadas automáticamente por fórmula (Volumen a envasar ÷ Presentación)</p>
                  </div>
                </header>

                {/* BANNER INTERACTIVO DE CÁLCULO AUTOMÁTICO DE ENTRADAS */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(16, 185, 129, 0.12) 0%, rgba(5, 150, 105, 0.08) 100%)",
                  border: "1.5px solid rgba(16, 185, 129, 0.4)",
                  borderRadius: "10px",
                  padding: "14px 16px",
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "14px"
                }}>
                  <ScienceIcon style={{ color: "#059669", fontSize: 32 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 800, color: "#065F46", fontSize: "13.5px" }}>
                      Cálculo Automático de Entradas (Número de Botellas):
                    </div>
                    <div style={{ fontSize: "12.5px", color: "#047857", marginTop: "3px" }}>
                      {currentVolumenEnvasar && capacidad ? (
                        <>
                          Volumen a envasar (<strong>{currentVolumenEnvasar} L</strong>) ÷ Presentación (<strong>{parseCapacityInLiters(capacidad)} L</strong> / {capacidad}) ={" "}
                          <span style={{ fontSize: "15px", fontWeight: 800, color: "#065F46", background: "rgba(16, 185, 129, 0.2)", padding: "2px 8px", borderRadius: "4px" }}>
                            {entradaBotellas || 0} botellas
                          </span>
                          {" "}(aprox. <strong>{entradaCajas || 0} cajas</strong> de {botCaja})
                        </>
                      ) : (
                        "Seleccione lote a granel, indique volumen y presentación para calcular automáticamente las botellas de entrada."
                      )}
                    </div>
                  </div>
                </div>

                <div className="species-grid">
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={entradaBotellas}
                      onChange={e => setEntradaBotellas(e.target.value)}
                      className="custom-input-field"
                      style={{ fontWeight: 700, color: "var(--agave-green)" }}
                      required
                    />
                    <label className="custom-input-label">Botellas Entrada (Calculado) *</label>
                  </div>

                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={entradaCajas}
                      onChange={e => setEntradaCajas(e.target.value)}
                      className="custom-input-field"
                      style={{ fontWeight: 700 }}
                    />
                    <label className="custom-input-label">Cajas Entrada (Calculado)</label>
                  </div>
                </div>

                <div className="custom-input-group" style={{ marginTop: 12 }}>
                  <input
                    type="text"
                    value={mermas}
                    onChange={e => setMermas(e.target.value)}
                    className="custom-input-field"
                    placeholder="Ej. 2 botellas (rotura en línea)"
                  />
                  <label className="custom-input-label">Mermas (Botellas dañadas)</label>
                </div>
              </section>

              {/* PASO 4: INVENTARIO INICIAL Y ENTRADAS DE HOLOGRAMAS (COMO EN LA IMAGEN) */}
              <section className="detail-card" style={{
                borderLeft: "4px solid #6B21A8",
                background: "#FFFFFF",
                boxShadow: "0 2px 8px rgba(107, 33, 168, 0.06)",
                gridColumn: "1 / -1"
              }}>
                <header className="detail-card-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px", borderBottom: "1px solid #F1F5F9", paddingBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "10px",
                      background: "rgba(107, 33, 168, 0.1)",
                      color: "#6B21A8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <ConfirmationNumberIcon style={{ fontSize: 24 }} />
                    </div>
                    <div>
                      <h2 style={{ fontSize: "16px", fontWeight: 700, color: "#1E293B", margin: 0 }}>
                        4. Control de Hologramas (Rango de Hologramas)
                      </h2>
                      <p style={{ fontSize: "13px", color: "#64748B", margin: "2px 0 0 0" }}>
                        Defina los folios inicial y final (con Prefijo A por defecto) para el cálculo automático de hologramas.
                      </p>
                      <div style={{ marginTop: "6px", display: "inline-block", background: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: "6px", padding: "4px 8px", fontSize: "11.5px", color: "#1E40AF" }}>
                        ℹ️ <strong>Regla de negocio:</strong> Si registra folios de hologramas, el lote avanzará a <strong>Envasado Terminado (Sección IV)</strong> en estatus <em>En revisión</em>. Si deja este apartado sin folios, permanecerá como <strong>No Terminado (Botella sin etiquetar)</strong>.
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={handleAddRangoHolograma}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      border: "none",
                      background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 100%)",
                      color: "#FFFFFF",
                      fontSize: "12.5px",
                      fontWeight: 700,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      boxShadow: "0 2px 6px rgba(107, 33, 168, 0.25)",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <AddIcon style={{ fontSize: 17 }} />
                    <span>Agregar otro rango de hologramas</span>
                  </button>
                </header>

                {/* LISTA DINÁMICA DE RANGOS DE HOLOGRAMAS */}
                <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "16px" }}>
                  {rangosHologramas.map((rangoItem, index) => (
                    <div
                      key={rangoItem.id}
                      style={{
                        padding: "16px",
                        background: "#FFFFFF",
                        border: "1.5px solid #E9D5FF",
                        borderRadius: "12px",
                        boxShadow: "0 1px 4px rgba(107, 33, 168, 0.05)"
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                        <span style={{
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "#6B21A8",
                          background: "#F3E8FF",
                          padding: "3px 10px",
                          borderRadius: "12px"
                        }}>
                          Rango #{index + 1}
                        </span>

                        {rangosHologramas.length > 1 && (
                          <button
                            type="button"
                            onClick={() => handleRemoveRangoHolograma(rangoItem.id)}
                            style={{
                              border: "none",
                              background: "transparent",
                              color: "#DC2626",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              fontSize: "12px",
                              fontWeight: 600,
                              padding: "4px 8px",
                              borderRadius: "6px"
                            }}
                            title="Eliminar este rango"
                          >
                            <CloseIcon style={{ fontSize: 16 }} />
                            <span>Quitar rango</span>
                          </button>
                        )}
                      </div>

                      {/* FILA 1: PREFIJO, RANGO 1 Y RANGO 2 */}
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                        gap: "12px",
                        marginBottom: "12px"
                      }}>
                        {/* PREFIJO (FIJO A) */}
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <select
                            value="A"
                            disabled
                            className="custom-select-field"
                            style={{ fontWeight: 700, background: "#F1F5F9", color: "#6B21A8", cursor: "not-allowed" }}
                            title="Prefijo A fijado por defecto"
                          >
                            <option value="A">Prefijo A</option>
                          </select>
                          <label className="custom-input-label">Prefijo (Fijo) *</label>
                        </div>

                        {/* RANGO 1 (FOLIO INICIAL) */}
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={rangoItem.rango1 ?? ""}
                            onChange={e => handleUpdateRangoHolograma(rangoItem.id, "rango1", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. 0123"
                            style={{ fontWeight: 600, background: "#FFFFFF" }}
                          />
                          <label className="custom-input-label">Rango 1 (Inicial) *</label>
                        </div>

                        {/* RANGO 2 (FOLIO FINAL) */}
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={rangoItem.rango2 ?? ""}
                            onChange={e => handleUpdateRangoHolograma(rangoItem.id, "rango2", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. 0500"
                            style={{ fontWeight: 600, background: "#FFFFFF" }}
                          />
                          <label className="custom-input-label">Rango 2 (Final) *</label>
                        </div>
                      </div>

                      {/* FILA 2: RANGO DE HOLOGRAMAS Y CANTIDAD CALCULADA */}
                      <div className="species-grid" style={{ marginBottom: 0 }}>
                        {/* RANGO DE HOLOGRAMAS */}
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="text"
                            value={rangoItem.rangoHologramas || rangoItem.rangoInicial || ""}
                            onChange={e => handleUpdateRangoHolograma(rangoItem.id, "rangoHologramas", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. A0123 - A0500"
                            style={{ fontWeight: 700, background: "#F8FAFC", color: "#1E293B" }}
                          />
                          <label className="custom-input-label">Rango de Hologramas</label>
                        </div>

                        {/* CANTIDAD CALCULADA */}
                        <div className="custom-input-group" style={{ margin: 0 }}>
                          <input
                            type="number"
                            value={rangoItem.cantidad || rangoItem.cantidadInicial || ""}
                            onChange={e => handleUpdateRangoHolograma(rangoItem.id, "cantidad", e.target.value)}
                            className="custom-input-field"
                            placeholder="Ej. 378"
                            style={{
                              fontWeight: 800,
                              background: "#FAF5FF",
                              color: "#6B21A8",
                              borderColor: "#D8B4FE"
                            }}
                          />
                          <label className="custom-input-label">Cantidad (Hologramas)</label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* RESUMEN DE TOTALES */}
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "14px",
                  padding: "12px 16px",
                  background: "#F3E8FF",
                  borderRadius: "8px",
                  fontSize: "13px",
                  color: "#581C87",
                  fontWeight: 600
                }}>
                  <span>Rangos Registrados: <strong>{totalHologramasResumen.totalRangos}</strong></span>
                  <span style={{
                    background: "#6B21A8",
                    color: "#FFFFFF",
                    padding: "4px 14px",
                    borderRadius: "6px",
                    fontWeight: 700,
                    fontSize: "13.5px"
                  }}>
                    Total Hologramas: {totalHologramasResumen.total}
                  </span>
                </div>
              </section>

              {/* PASO 5: INVENTARIO FINAL CALCULADO Y OBSERVACIONES */}
              <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
                <header className="detail-card-header">
                  <div className="detail-card-icon-wrapper-green">
                    <CheckCircleIcon />
                  </div>
                  <div className="detail-card-title-wrapper">
                    <h2>5. Inventario Final Calculado y Observaciones</h2>
                    <p>Saldo final de botellas desnudas sin etiquetar disponibles en inventario</p>
                  </div>
                </header>

                <div className="species-grid" style={{ marginTop: 12 }}>
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={calcFinalCajas}
                      readOnly
                      className="custom-input-field"
                      style={{ opacity: 0.9, fontWeight: 700, color: "var(--agave-green)" }}
                    />
                    <label className="custom-input-label">Nº Cajas Finales (Calculado)</label>
                  </div>

                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={calcFinalBotellas}
                      readOnly
                      className="custom-input-field"
                      style={{ opacity: 0.9, fontWeight: 700, color: "var(--agave-green)" }}
                    />
                    <label className="custom-input-label">Nº Botellas Finales (Calculado)</label>
                  </div>
                </div>

                <div className="custom-input-group" style={{ marginTop: 20 }}>
                  <textarea
                    value={observaciones}
                    onChange={e => setObservaciones(e.target.value)}
                    className="custom-input-field"
                    style={{ height: "80px", resize: "none", padding: "14px" }}
                    placeholder="Notas generales sobre el lote de envasado no terminado..."
                  />
                  <label className="custom-input-label">Observaciones</label>
                </div>
              </section>

              {/* Footer de Acciones del Modal */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "12px", borderTop: "1px solid #E2E8F0" }}>
                <button
                  type="button"
                  onClick={() => setIsFormOpen(false)}
                  className="btn-cancel-modal"
                >
                  Cancelar
                </button>

                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => handleSaveNoTerminado("borrador", { rangosHologramas })}
                    className="btn-cancel-modal"
                    style={{ background: "#F1F5F9", color: "#475569", border: "1px solid #CBD5E1", fontWeight: 700 }}
                  >
                    Guardar Borrador
                  </button>

                  <button
                    type="submit"
                    className="destilacion-btn-new"
                    style={{ background: "linear-gradient(135deg, #059669 0%, #10B981 100%)", boxShadow: "0 4px 14px rgba(5, 150, 105, 0.3)" }}
                  >
                    <CheckCircleIcon style={{ fontSize: 18 }} />
                    <span>Guardar Registro de Envasado de Producto</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default EnvasadoNoTerminadoSection;
